import React from 'react';
import { ClockIcon, FileBadgeIcon } from 'lucide-react';
import { permitTypes, type PermitType } from '../../data/permis';
interface PermitCatalogueProps {
  onSelect: (type: PermitType) => void;
}
export function PermitCatalogue({
  onSelect
}: PermitCatalogueProps) {
  return <section aria-labelledby="types-permis-titre" data-id="element-2410" data-mp="11t35u09faoi1">
      <h2 id="types-permis-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-2411" data-mp="11uo3hyr1ank4">
        Permis les plus demandés
      </h2>
      <p className="mt-1 text-[15px] text-slate-600" data-id="element-2412" data-mp="1atrkmx6n4svz">Frais et délais d’analyse à jour.</p>

      <ul className="mt-6 space-y-3" data-id="element-2413" data-mp="1fkhsch2jh7tu">
        {permitTypes.map(type => <li key={type.id} className="flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4" data-id="element-2414" data-mp="1fl9lll8nytgy">
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-slate-100 text-ville-navy" aria-hidden="true" data-id="element-2415" data-mp="1pjqi0xqdg0ae">
              <FileBadgeIcon className="h-5 w-5" data-id="element-2416" data-mp="2qivgojxq62bd" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-2417" data-mp="2qfzicuhytbme">
              <h3 className="font-bold text-ville-navy" data-id="element-2418" data-mp="2lizk35rcxd5u">{type.name}</h3>
              <p className="text-sm text-slate-500" data-id="element-2419" data-mp="2gjwg7on45czg">{type.detail}</p>
              <p className="mt-1 flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2420" data-mp="2gm8wzyh4xhax">
                <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-2421" data-mp="2ck5lxaydoeq6" />
                {type.processingTime}
              </p>
            </div>
            <div className="text-right" data-id="element-2422" data-mp="349qw6f2qbhnx">
              <p className="font-extrabold text-ville-navy" data-id="element-2423" data-mp="34b1wu60vo9at">{type.fee}</p>
              <button type="button" onClick={() => onSelect(type)} className="mt-2 rounded-full border border-ville-navy px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:bg-ville-navy hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-2424" data-mp="2ziig506w8y1s">
                Demander
              </button>
            </div>
          </li>)}
      </ul>
    </section>;
}